module.exports = "<div id=\"dashboard-map\">\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/dashboard/dashboard-map/dashboard-map.component.html
// module id = ../../../../../src/app/dashboard/dashboard-map/dashboard-map.component.html
// module chunks = main